/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Image } from 'semantic-ui-react';
import ChangePasswordForm from '../containers/ChangePasswordForm';
import AuthLayout from '../../../layouts/components/AuthLayout';

const Logo = styled(Image)`
  margin: 0 auto 3em auto;
`;

const ChangePasswordPage = ({ match }) => (
    <AuthLayout>
        <Logo src="/images/appotime-logo-dashboard.png" />
        <ChangePasswordForm token={match.params.token} />
    </AuthLayout>
);

export default ChangePasswordPage;
